// extracted by mini-css-extract-plugin
module.exports = {"xs":"0","sm":"430","md":"960","lg":"1264","xl":"1904"};